/** Used when embed options omit `apiEndpoint` and no `VITE_API_BASE_URL` is set at build time. */
export const DEFAULT_API_ENDPOINT =
    'https://ai-classifier.cloud.pmmimediagroup.com'
